export default __webpack_public_path__ + "static/media/FUNKE_Medien_National_rgb_red_black_72dpi.8080504f.jpg";